export default __webpack_public_path__ + "static/media/176.e4900d31.png";